// extracted by mini-css-extract-plugin
export default {"button":"hr-z","reviewSort":"ir-z"};